import { filledInputClasses } from "@mui/material/FilledInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import { Input } from "components/input";

export const Component = styled(Input, {
  label: "input",
})`
  &,
  .${inputLabelClasses.root},
    .${filledInputClasses.root},
    .${filledInputClasses.input} {
    cursor: pointer;
  }
`;
